import * as React from 'react';
import { Typography, Box, Grid, Snackbar, Alert } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useEffect, useState } from 'react';
import { resolveQuarantine, selectResolveQuarantineStatus, selectResolveQuarantineError, resetQuarantineState } from '../../app/slices/quarantineSlice';
import QuarantineDialogBox from './QuarantineDialogBox';
import { MARK_RESOLVE_TITLE } from './QuarantinePageMessages';

interface IProps {
  eventId?: string;
  runReport: Function;
}

export default function QuarantineResolve({ eventId, runReport }: IProps) {
  const dispatch = useAppDispatch();

  const resolveQuarantineStatus = useAppSelector(selectResolveQuarantineStatus);
  const resolveQuarantineError = useAppSelector(selectResolveQuarantineError);

  const [openDialog, setOpenDialog] = useState(false);

  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');


  const closeAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlert(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (resolveQuarantineStatus === 'FAILED' && resolveQuarantineError) {
      setAlertMessage(resolveQuarantineError);
      setAlert(true);
    } else if (resolveQuarantineStatus === 'SUCCESS') {
      setAlertMessage('Resolved');
      setAlert(true);
      runReport();
      handleClose();
      dispatch(resetQuarantineState());
    }
  }, [resolveQuarantineError, resolveQuarantineStatus]);

  const markResolve = () => {
    setOpenDialog(true);
  };

  const confirmResolve = () => {
    dispatch(resolveQuarantine({ oldEventId: eventId }));
  };
  return (<>
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' sx={{ fontWeight: '600', pt: 2, pb: 0, pl: { xs: 15, md: 25 } }} >OR</Typography>
      <Grid
        container
        alignItems='center'
        justifyContent='flex-start'
        spacing={2}
        paddingTop={1}
      >
        <Grid item md={7} sm={6} xs={12}>
          <Typography>Mark the event as resolved if images do not need to be uploaded: </Typography>
        </Grid>
        <Grid item md={3} sm={3} xs={12}>
          <LoadingButton
            fullWidth
            variant='contained'
            disabled={!eventId}
            loadingPosition='end'
            endIcon={''}
            type='submit'
            onClick={markResolve}
          >
            Mark Event as Resolved
          </LoadingButton>
        </Grid>
      </Grid>
      <QuarantineDialogBox
        heading={MARK_RESOLVE_TITLE}
        detailReason={markResolveMsg(eventId)}
        openDialog={openDialog}
        closeDialog={handleClose}
        showConfirmButton={true}
        confirm={confirmResolve}
        status={resolveQuarantineStatus}
      ></QuarantineDialogBox>
    </Box>
    {<Snackbar
      open={alert}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={closeAlert}
    >
      {alertMessage === 'Resolved' ? (
        <Alert severity='success'>{alertMessage}</Alert>
      ) : (
        <Alert severity='error'>{alertMessage}</Alert>
      )}
    </Snackbar>}
  </>
  );
}

export function markResolveMsg(eventId?: string): string {
  return `Files/Images in the Quarantine bin from ${eventId} will now be marked as resolved and do not need to be uploaded`;
}